<template>
  <Fragment>
    <template v-if="$route.name !== 'baseDataCountry'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>国家名称：</span>
              <el-input v-model="baseDataCountryName"> </el-input>
            </div>
            <div class="search-name mr-15">
              <span>国家名称英文简称：</span>
              <el-input v-model="baseDataCountryShortName"> </el-input>
            </div>
            <div class="search-name mr-15">
              <span>OID编码：</span>
              <el-input v-model="baseDataCountryOidCode"> </el-input>
            </div>
            <el-button
              type="primary"
              class="ml-20"
              @click="searchBaseDataCountryInfo"
              >查询</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="国家名称" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.baseDataCountryName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="国家名称英文简称" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.baseDataCountryShortName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="OID编码" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.baseDataCountryOidCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="着陆页" width="450">
          <template slot-scope="scope">
            <span>{{ scope.row.baseDataCountryUrl }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :fit="true">
          <template slot-scope="scope">
            <el-button size="mini" @click="editCountryInfo(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      baseDataCountryName: "",
      baseDataCountryShortName: "",
      baseDataCountryOidCode: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getBaseDataCountryCodeList() {
      let _this = this;
      let param = {
        url: "/api/country/getBaseDataCountryList",
        params: {
          baseDataCountryName: _this.baseDataCountryName,
          baseDataCountryShortName: _this.baseDataCountryShortName,
          baseDataCountryOidCode: _this.baseDataCountryOidCode,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getBaseDataCountryCodeList", param).then(() => {
        _this.list = _this.$store.state.country.baseDataCountryCodeList.list;
        _this.total = _this.$store.state.country.baseDataCountryCodeList.total;
      });
    },
    //查询
    searchBaseDataCountryInfo() {
      let _this = this;
      _this.getBaseDataCountryCodeList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getBaseDataCountryCodeList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getBaseDataCountryCodeList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getBaseDataCountryCodeList();
    },
    //编辑
    editCountryInfo(row) {
      this.$router.push({
        name: "editCountryInfo",
        params: { baseDataCountryId: row.baseDataCountryId }
      });
    }
  },
  created() {
    let _this = this;
    _this.getBaseDataCountryCodeList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
